import React, { useState } from 'react';
import PropTypes from 'prop-types';

import { Checkbox, Input } from '@studio/legacy-components';
import useToggle from 'next/hooks/use-toggle';
import { OptionWrapper } from './styled';

export const RedirectAction = ({ onSave, schemeLink = '' }) => {
  const [draftSchemeLink, setDraftSchemeLink] = useState(schemeLink);
  const [showRedirectInput, toggleShowRedirectInput] = useToggle(!!schemeLink);
  const showRedirectAction = showRedirectInput || !!draftSchemeLink;

  const handleClickRedirectCheckbox = () => {
    if (showRedirectAction) {
      setDraftSchemeLink('');
      onSave({ redirectUrl: null });
    }
    toggleShowRedirectInput();
  };

  return (
    <OptionWrapper>
      <Checkbox
        checked={showRedirectAction}
        onChange={handleClickRedirectCheckbox}
      >
        Redirect to a different screen
      </Checkbox>
      {showRedirectInput && (
        <Input
          aria-label="Scheme link"
          onBlur={({ target: { value } }) => onSave({ redirectUrl: value })}
          onChange={({ target: { value } }) => setDraftSchemeLink(value)}
          placeholder="Scheme link"
          type="text"
          defaultValue={draftSchemeLink}
        />
      )}
    </OptionWrapper>
  );
};

RedirectAction.propTypes = {
  onSave: PropTypes.func,
  schemeLink: PropTypes.string,
};

export default RedirectAction;
